import * as React from "react";

import { Container, Stack } from "@mui/material";

import { PageHeader } from "@/components/organisms/PageHeader";
import { BusyOverlay } from "@/components/atoms/BusyOverlay";
import { ErrorSnackbar } from "@/components/organisms/ErrorSnackbar";

export type SimpleTemplateDesktopProps = {
  busy?: boolean;
  errorMessage?: string;
  header: React.ReactNode;
  children: React.ReactNode;
  removeErrorMessage?: () => void;
};

export const SimpleTemplateDesktop: React.FC<SimpleTemplateDesktopProps> = ({
  busy,
  errorMessage,
  header,
  children,
  removeErrorMessage,
}) => {
  return (
    <BusyOverlay hidden={!busy}>
      <Stack rowGap="60px" sx={{ minHeight: "100vh" }}>
        {header || <PageHeader includeLogo={true} />}

        <Container sx={{ paddingBottom: 4 }}>{children}</Container>

        <ErrorSnackbar error={errorMessage} onClose={removeErrorMessage} />
      </Stack>
    </BusyOverlay>
  );
};
